import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-lv",
  "use": "icon-icon-lv-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-lv\">\n  <g fill-rule=\"evenodd\">\n    <path fill=\"#fff\" d=\"M0 0h512v512H0z\" />\n    <path fill=\"#981e32\" d=\"M0 0h512v204.8H0zm0 307.2h512V512H0z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol